// Attachment entity types
export const EntityType = {
  RESOURCE: "resource",
  BORROWING: "borrowing",
  LOCATION: "location",
  CATEGORY: "category"
};

// Attachment contexts
export const AttachmentContext = {
  GENERAL: "general",
  START_BORROWING: "start_borrowing",
  RETURN_BORROWING: "return_borrowing"
};

// File types
export const FileType = {
  IMAGE: "image",
  DOCUMENT: "document"
};
